<section class="content-header">
    <div class="container-fluid">
      <div class="row mb-2">
        <div class="col-sm-6">
          <h1>Status of Services</h1>
        </div>
        <div class="col-sm-6">
          <ol class="breadcrumb float-sm-right">
            <li class="breadcrumb-item"><a href="#">Home</a></li>
            <li class="breadcrumb-item active">Blank Page</li>
          </ol>
        </div>
      </div>
    </div>
    <!-- /.container-fluid -->
  </section>

  <section class="content">
    <!-- Default box -->
    <div class="row">

    </div>
    <div class="container-fluid">
        <div class="row">
        
        
            <div class="col-lg-12" >
                <div class="card ">
                    <div class="card-header">
                      <h3 class="card-title">List</h3>
                      <div class="card-tools">
                        <!-- Buttons, labels, and many other things can be placed here! -->
                        <!-- Here is a label for example -->
                        <span class="badge badge-primary">DEV</span>
                      </div>
                      <!-- /.card-tools -->
                    </div>
                    <!-- /.card-header -->
                    <div class="card-body">
                        <ngx-json-viewer [json]="statusData" [expanded]="true"></ngx-json-viewer>
                    </div>
                    <!-- /.card-body -->
                    <div class="card-footer">
                      The footer of the card
                    </div>
                    <!-- /.card-footer -->
                </div>
            </div>
        </div>
        
          <!-- /.card -->
    </div>
    <!-- /.card -->
  </section>